module.exports = __webpack_public_path__ + "media/images/keyhole-994ba36c3409fd30bb018e50b0bbc7d9.svg";